'use strict';

var _defineProperty = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var getIterator = require('get-iterator'); // a pair of streams where one drains from the other


module.exports = function pair() {
  var _source2;

  var _source, _onSource;

  var sink = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_source) {
                _context.next = 2;
                break;
              }

              throw new Error('already piped');

            case 2:
              _source = getIterator(source);
              if (_onSource) _onSource(_source);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sink(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var source = (_source2 = {}, _defineProperty(_source2, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_source2, "next", function next() {
    if (_source) return _source.next();
    return new Promise(function (resolve) {
      _onSource = function onSource(source) {
        _onSource = null;
        resolve(source.next());
      };
    });
  }), _source2);
  return {
    sink: sink,
    source: source
  };
};